<template>
  <el-tooltip class="item" effect="dark" content="输入数字时按ID查询，中文按姓名查询，完整手机号按手机号查询，否则按账号查询, 需指定代理商查询" placement="top">
    <el-select
            v-model="data"
            value-key="name"
            v-bind="$attrs"
            filterable
            remote
            :remote-method="search"
            :loading="loading"
            @change="onChange"
            @clear="onClean"
            ref="factorAutoComplete"
            placeholder="请输入用户账号/姓名/ID/手机号"
            :disabled="disabled"
    >
      <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.title"
              :value="item.id">
      </el-option>
    </el-select>
  </el-tooltip>
</template>
<script>
    import { getAdminAutoComplete } from '@/service/user'
    // 目前不支持多选
    export default{
        props: {
            value: [Number, String],
            factorId: [Number, String],
            initChooseFirst: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                data: null,
                loading: false,
                options: [],
                searchTimeOutHandle: null,
                disabled: true
            }
        },
        created() {
            if (!!this.factorId === true) {
                this.disabled = false
                this.search(this.value, true)
            }
        },
        watch: {
            factorId(val) {
                this.onClean()
                this.search('')
            },
            value(val) {
                if (val !== this.data) {
                    this.search(val)
                }
            }
        },
        methods: {
            search(query, isInit = false) {
                this.loading = true
                clearTimeout(this.searchTimeOutHandle)
                if (!!this.factorId === false) {
                    this.onClean()
                    return
                }
                let conditions = {
                    factor_id: this.factorId
                }

                if (!!query) {
                    if (/^1[3456789]\d{9}$/.test(query)) {
                        conditions.mobile = query
                    } else if (/^\d+$/.test(query)) {
                        conditions.id = query
                    } else if (/^[\u4e00-\u9fa5]+$/.test(query)) {
                        conditions.name = query
                    } else {
                        conditions.account = query
                    }
                }
                let that = this
                let timeout = isInit ? 0 : 300
                this.searchTimeOutHandle = setTimeout(() => {
                    getAdminAutoComplete(conditions).then(response => {
                        that.loading = false
                        that.options = response
                        that.data = null
                        if (response.length > 0) {
                            that.options.forEach((item, key) => {
                                if (item.id === that.value) {
                                    that.data = that.value
                                }
                                item['title'] = `${item.account} [${item.name}]`
                                that.options[key] = item
                            })
                            if (that.initChooseFirst && !!that.value === false) {
                                that.data = response[0].id
                            }
                        }
                        that.onChange()
                        if (isInit) {
                            that.$emit('created', that.data)
                        }
                    }).catch(err => {
                        console.log(err)
                        that.loading = false
                    })
                }, timeout)
            },
            onChange(item) {
                this.$emit('input', this.data)
            },
            onClean() {
                if (!!this.factorId === false) {
                    this.disabled = true
                    this.options = []
                } else {
                    this.disabled = false
                }
                // this.options = []
                this.data = null
                this.$emit('input', '')
            }
        }
    }
</script>
